import { render, staticRenderFns } from "./ProvTradeCom.vue?vue&type=template&id=0b3ef381&scoped=true&"
import script from "./ProvTradeCom.vue?vue&type=script&lang=js&"
export * from "./ProvTradeCom.vue?vue&type=script&lang=js&"
import style0 from "./ProvTradeCom.vue?vue&type=style&index=0&id=0b3ef381&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3ef381",
  null
  
)

export default component.exports